import { SCAccount } from "../../providers";
import { Profile } from "./requests";

export enum PermissionLevel {
  NONE = "NONE",
  READ = "READ",
  WRITE = "WRITE",
}

export interface AssistantPermission {
  componentId: string;
  level: PermissionLevel;
}

interface AssistantAccount {
  user: SCAccount;
  profile: Profile;
  permissions?: AssistantPermission[];
}

export interface Assistant {
  userId: number;
  account: AssistantAccount;
  branchNames: string[];
  regionNames: string[];
  segmentationDetails: SegmentationDetail[];
}

export interface SegmentationDetail {
  segmentationDetailId: number;
  coachId: string | number;
  type: string; // "STATE" | "REGION" | "BRANCH";
  name?: string;
}
